import getWithToken from './base/get-with-token'

const getAlertsOverview = getWithToken(`/alerts/overview`)

export default getAlertsOverview
